export const StatStrip = ({ totals }) => {
  const items = [
    ["Companies", totals.companies],
    ["Dispatchers", totals.dispatchers],
    ["Drivers", totals.drivers],
    ["Customers", totals.customers],
    ["Rides", totals.rides],
    ["Suspended", totals.suspended],
  ];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-slate-200 rounded-2xl overflow-hidden border border-slate-200 mb-8" data-testid="owner-stat-strip">
      {items.map(([label, value], i) => (
        <div key={label} className="bg-white px-5 py-4 owner-rise" style={{ animationDelay: `${i * 50}ms` }}>
          <p className="text-xs uppercase tracking-[0.14em] text-slate-500 font-semibold">{label}</p>
          <p className="font-heading text-3xl font-black text-slate-900 mt-1" data-testid={`owner-stat-${label.toLowerCase()}`}>{value ?? 0}</p>
        </div>
      ))}
    </div>
  );
};
